<template>
  <div v-if="fundMonthlyReport">
    <a-descriptions title="Fund Info" layout="vertical" :column="2" bordered>
      <a-descriptions-item label="Total Assets">
        <span v-if="fundMonthlyReport.totalAssets">
          {{ fundMonthlyReport.totalAssets.amount | formatMoney }}
          {{ fundMonthlyReport.totalAssets.currency }}
        </span>
        <span v-else>
          -
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Total Investments">
        <span v-if="fundMonthlyReport.totalInvestments">
          {{ fundMonthlyReport.totalInvestments.amount | formatMoney }}
          {{ fundMonthlyReport.totalInvestments.currency }}
        </span>
        <span v-else>
          -
        </span>
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions
      v-for="classReport in fundMonthlyReport.classReports"
      :key="classReport.class.name"
      class="mt-8"
      :title="classReport.class.name"
      layout="vertical"
      :column="2"
      bordered
    >
      <a-descriptions-item label="Share Value">
        <span v-if="classReport.shareValue">
          {{ classReport.shareValue.amount | formatMoney }}
          {{ classReport.shareValue.currency }}
        </span>
        <span v-else>
          -
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Dividend">
        <span v-if="classReport.dividend">
          {{ classReport.dividend.amount | formatMoney }}
          {{ classReport.dividend.currency }}
        </span>
        <span v-else>
          -
        </span>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    fundMonthlyReport: {
      query: gql`
        query GetFundMonthlyReport($fundId: Uuid!, $year: Int!, $month: Int!) {
          fundMonthlyReport(fundId: $fundId, year: $year, month: $month) {
            totalAssets {
              amount
              currency
            }
            totalInvestments {
              amount
              currency
            }
            classReports {
              class {
                name
              }
              shareValue {
                amount
                currency
              }
              dividend {
                amount
                currency
              }
            }
          }
        }
      `,
      variables() {
        return {
          fundId: this.report.fundId,
          year: this.report.year,
          month: this.report.month,
        }
      },
    },
  },
  data() {
    return {
      fundMonthlyReport: null,
    }
  },
}
</script>

<style></style>
